import { FC } from 'react';
import { Dialog } from 'primereact/dialog';
import { Unit } from '../../models/Unit';
import { getFocusUnitTheme } from '../../businessLogicService/focusUnitTheme';
import { FocusIndicatorBadge } from './FocusIndicatorBadge';

interface Props {
  visible: boolean;
  unit: Unit;
  onStart: () => void;
}

export const NewFocusModal: FC<Props> = ({ visible, unit, onStart }) => {
  const theme = getFocusUnitTheme(unit);

  return (
    <Dialog
      visible={visible}
      onHide={() => undefined}
      closable={false}
      dismissableMask={false}
      closeOnEscape={false}
      draggable={false}
      resizable={false}
      showHeader={false}
      appendTo="self"
      className="!tw-w-[600px] !tw-max-w-[92vw] !tw-rounded-[32px] tw-overflow-hidden !tw-p-0"
      contentClassName="!tw-p-0"
    >
      <div className={`tw-flex tw-flex-col tw-overflow-hidden tw-rounded-[32px] ${theme.panel}`}>
        <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-96 tw-gap-6 tw-overflow-hidden tw-px-16 tw-py-10">
          <div aria-hidden className={`tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-focus-grid ${theme.grid}`} />
          {/* MY NEW FOCUS pill (Figma node 2402:84996) */}
          <FocusIndicatorBadge />

          <div
            className={`tw-relative tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-2.5 tw-rounded-2xl tw-border-4 tw-border-b-8 tw-border-solid tw-bg-stone-0 tw-p-6 tw-text-center ${theme.card}`}
          >
            <p className="tw-font-atkinson tw-text-lg tw-leading-7 tw-m-0 tw-text-ph2-primary">Unit {unit.name}:</p>
            <p className="tw-font-sora tw-text-3xl tw-font-bold tw-leading-9 tw-m-0 tw-text-ph2-primary">
              {unit.summary || unit.name}
            </p>
          </div>
        </div>

        <div className="tw-flex tw-items-center tw-justify-center tw-rounded-bl-[32px] tw-rounded-br-[32px] tw-border-x-2 tw-border-b-4 tw-border-solid tw-border-stone-100 tw-bg-white tw-px-6 tw-py-4">
          <button
            type="button"
            onClick={onStart}
            className="tw-cursor-pointer tw-rounded-full tw-border-none tw-bg-indigo-600 tw-px-6 tw-py-3 tw-font-atkinson tw-text-base tw-font-bold tw-leading-5 tw-text-white"
          >
            Start my new focus
          </button>
        </div>
      </div>
    </Dialog>
  );
};
